import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import DefaultButton from './DefaultButton';
import Triangle from '../../../assets/svg/Triangle';
import HandOffLink from '../../../utils/urls/HandOffLink';

import colors from '../../../styling/colors';

const List = styled.ul`
  background: ${colors('white')};
  border: none;
  box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.2);
  color: ${colors('white')};
  right: 0;
  list-style: none;
  padding: 8px 0px;
  position: absolute;
  text-align: left;
  margin: 0;
  min-width: 100%;
`;

const Item = styled.li`
  padding: 0;
  margin: 0;
`;

const linkStyles = css`
  display: block;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 1.25em;
  text-decoration: none;
  text-transform: none;
  color: ${colors('lapel')};

  &:active,
  &:hover,
  &:focus {
    background-color: ${colors('dove')};
    cursor: pointer;
  }
`;

const Container = styled.div`
  position: relative;
`;

const StyledTriangle = styled(Triangle)`
  margin-left: 10px;
`;

export default class DropdownButton extends Component {
  static propTypes = {
    text: PropTypes.any.isRequired,
    color: PropTypes.string,
    className: PropTypes.string,
    links: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
      }),
    ),
  };

  state = {
    open: false,
  };

  onClick = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { className, color, text, links } = this.props;

    const { open } = this.state;

    const Link = styled(HandOffLink)`
      ${linkStyles};
    `;

    return (
      <Container className={className}>
        <DefaultButton color={color} onClick={this.onClick}>
          {text}
          <StyledTriangle
            height="10px"
            width="10px"
            direction={open ? 'up' : 'down'}
            strokeColor={color === 'white' ? colors('lapel') : colors('white')}
          />
        </DefaultButton>
        {open ? (
          <List>
            {links.map((link, i) => {
              return (
                <Item key={i}>
                  <Link href={link.href} identifier={link.text}>
                    {link.text}
                  </Link>
                </Item>
              );
            })}
          </List>
        ) : null}
      </Container>
    );
  }
}
